import { useEffect, useCallback } from 'react';
import Icon from '@components/icons/Icon';
import styles from '@components/Aside/Aside.styles';
import Button from '@components/Button/Button';
import { TButtonVariantColor, TButtonVariantBackgroundColor } from '@components/Button/typescript';
import useBodyOverflow from '@hooks/useBodyOverflow';
export type AsidePropsType = {
  children: React.ReactNode;
  active: boolean;
  buttonCloseVariantColor?: TButtonVariantColor;
  buttonCloseVariantBackgroundColor?: TButtonVariantBackgroundColor;
  useCurtain?: boolean;
  size?: 'default' | 'large' | 'frontConfigurator';
  hiddenButtonClose?: boolean;
  onCloseAside: (...args: unknown[]) => void;
};
const Aside = ({
  children,
  active,
  buttonCloseVariantColor = undefined,
  buttonCloseVariantBackgroundColor = undefined,
  useCurtain = true,
  size = 'default',
  hiddenButtonClose = false,
  onCloseAside
}: AsidePropsType): JSX.Element => {
  const handleKeyUp = useCallback((event: KeyboardEvent) => {
    const {
      key
    } = event;
    if (key === 'Escape') onCloseAside(event);
  }, [onCloseAside]);
  const onOverlayClick = (event: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
    if (event.target === event.currentTarget && event.button === 0) onCloseAside(event);
  };
  useBodyOverflow(active, 'aside', true, true);
  useEffect(() => {
    if (active) {
      window.addEventListener('keyup', handleKeyUp);
    } else {
      window.removeEventListener('keyup', handleKeyUp);
    }
    return () => window.removeEventListener('keyup', handleKeyUp);
  }, [active, handleKeyUp]);
  return (
    // eslint-disable-next-line jsx-a11y/no-static-element-interactions
    <div data-cy="CartSideBar" sx={styles.overlay(active, useCurtain)} onMouseDown={onOverlayClick}>
      <aside sx={styles.aside(active, size || 'default')}>
        <div sx={styles.asideContent}>
          {!hiddenButtonClose && <Button variant="iconOnly" type="button" addSx={styles.asideCloseButton} onClick={onCloseAside} cy="CloseAsideCartButton" variantColor={buttonCloseVariantColor} variantBackgroundColor={buttonCloseVariantBackgroundColor}>
              <Icon size={['24px', '24px', '24px', '24px', '24px', '32px']} icon="Close3" />
            </Button>}
          {children}
        </div>
      </aside>
    </div>
  );
};
export default Aside;